<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.identification' | translate }}</label>
    <input type="text" appInput formControlName="meteringPointIdentification" readonly placeholder="{{ 'meteringpoint.identification' | translate }}" />
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'date.validFrom' | translate }}</label>
    <input type="date" appInput formControlName="occurrence" placeholder="{{ 'date.enterDate' | translate }}" />
  </app-input-group>
</form>
